import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NAV_ITEMS } from '@shared/containts';
import { type IToggleItem } from '@shared/models';

@Component({
  selector: 'app-toggle',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './toggle.html',
  styleUrl: './toggle.scss',
})
export class Toggle {
  items = input<IToggleItem[]>(NAV_ITEMS);
}
